import { createContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "../services/api/axiosInstance";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { handleReset } from "Actions/commonAction/milleSearchFilterActions";
import Cookies from "js-cookie";

const employerContext = createContext();

export const DataProvider = ({ children }) => {
  const { location } = useSelector((state) => state.milleSearchStates);
  const dispatch = useDispatch();
  const [subscription_going_to_end, set_subscription_going_to_end] = useState(0);
  const [is_trial_started, set_is_trial_started] = useState("")
  const [pricingResponse, setPricingResponse] = useState({})
  const [subscriptionExpiredShow, setSubscriptionExpired] = useState(false);
  const [applicantFeedbackModel, setApplicantFeedbackModel] = useState(false);
  const [applicantFeedback, setApplicantFeedback] = useState("")
  const [selectedJobRoleId, setSelectedJobRoleId] = useState(null)
  const [profile, setProfilePicture] = useState("");
  const [openWidget, setOpenWidget] = useState(false);
  const [smallDevice, setSmallDevice] = useState(false);
  const [selectCandidateStatus, setSelectCandidateStatus] = useState(false);
  const [rejectCandidateStatus, setRejectCandidateStatus] = useState(false);
  const [inviteToInterviewStatus, setinviteToInterviewStatus] = useState(false);
  const [candidatesList, setCandidatesList] = useState([]);
  const [candidatesListDuplicate, setCandidatesListDuplicate] = useState([]);
  const [jobRole, setJobRole] = useState([]);
  const [keepNotes, setKeepNotes] = useState("");
  const [rightSideContent, setRightSideContent] = useState({});
  const [filterSkills, setFilterSkills] = useState([]);
  const [filterLocation, setFilterLocation] = useState([]);
  const [professionalId, setProfessionalId] = useState(0);
  const [jobId, setJobId] = useState(0);
  const [role, setRole] = useState("");
  const [appStatus, setAppStatus] = useState("");
  const [initialGlow, setInitialGlow] = useState(false);
  const [cardSelectedGlow, setCardSelectedGlow] = useState(false);
  const [categorySelectedGlow, setCategorySelectedGlow] = useState(false);
  const [roleStatus, setRoleStatus] = useState("Opened")
  const [jobStatus, setJobStatus] = useState("All");
  const [mellieSearchSkills, setMellieSearchSkills] = useState([]);
  const [mellieSearchLocations, setMellieSearchLocations] = useState([]);
  const [updateKeepNotes, setUpdatingKeepNotes] = useState(false);
  const [updateClearNotes, setUpdatingClearNotes] = useState(false);
  const [jobListContent, setJobListContent] = useState({
    id: 0,
    job_title: "",
    posted_on: "",
    company_name: "",
    job_status: ""
  });

  const [contentForEmail, setContentForEmail] = useState({
    id: 0,
    job_title: "",
    posted_on: "",
    company_name: "",
    job_status: "",
    designation: "",
    first_name: "",
    last_name: "",
    email_id: ""
  });

  const [recommendedDatas, setRecommendedDatas] = useState({
    sc_recommended_notes: "",
    recommended_by: ""
  });

  const [employerExpertNotes, setEmployerExpertNotes] = useState("");
  const [pageThreeSkillDataResponse, setPageThreeSkillDataResponse] = useState([]);

  // joyride
  const employerProfileDropdown = "employerProfileDropdown";
  const employerApplicants = "applicantsTab";
  const employerPool = "poolTab";

  //home page states
  const [postDraftTemplate, setPostDraftTemplate] = useState(false);
  const [existingTemplate, setExistingTemplate] = useState(false);
  const [selctedTemplateCard, setSelectedTemplateCard] = useState(false)
  const [pageOneLoading, setPageOneLoading] = useState(true);
  const [homeResponseReview, setHomeResponseReview] = useState(false);
  const [getJobApi, setGetJobApi] = useState([]);
  const [editingJobStatus, setEditingJobStatus] = useState("");
  const [postButton, setPostButton] = useState('false')
  const [createJobId, setCreateJobId] = useState({
    key_id: 0,
    job_title: "",
    job_type: "",
    work_schedule: "",
    workplace_type: "",
    country: "",
    city: "",
    job_overview: "",
    specialisation: "",
    required_subcontract: "",
    skills: "",
    time_zone: null,
    job_desc: "",
    required_resume: "",
    required_cover_letter: "",
    required_background_check: "",
    time_commitment: "",
    duration: "",
    job_status: "",
    is_paid: "",
    is_active: "",
    pre_screen_ques: [],
  });

  const [pageTwoJobDetails, setPageTwoJobDetails] = useState({
    jobTitle: "",
    jobOverview: "",
    workplaceType: "Select",
    // location: "Select",
    jobType: "Select",
    timeCommitment: "Select",
    timeZone: "Select",
    schedule: "Select",
    duration: "0-Select",
    compensation: "",
  });

  const [jobLocation, setJobLocation] = useState({
    city: "",
    country: "",
  });

  const [pageThreeJobDetails, setPageThreeJobDetails] = useState({
    jobDescription: null,
    skills: [],
    specialization: "Select",
  });

  const [specificSpecialization, setSpecificSpecialization] = useState('')
  const [showingJobLocation, setShowingJobLocation] = useState("")
  const [editCompanyLocation, setEditCompanyLocation] = useState({
    city: "",
    country: "",
  });

  const [pageFourJobDetails, setPageFourJobDetails] = useState({
    resume: "",
    coverLetter: "",
    bgCheck: "",
    hiring: "",
    questions: [],
    receive_notification: "Y"
  });

  const [txtdurations, settxtDurations] = useState({
    count: "0",
    format: 'Select'
  })

  const [showReview, setShowReview] = useState(true)
  const [showFieldOne, setShowFieldOne] = useState(true)
  const [showFieldTwo, setShowFieldTwo] = useState(false)
  const [showFieldThree, setShowFieldThree] = useState(false)
  const [showFieldFour, setShowFieldFour] = useState(false)

  const [showProgressBar, setShowProgressBar] = useState(true);
  const [editingJobFromHome, setEditingJobFromHome] = useState(false);

  var currentStep = 1;
  var updateProgressBar;

  const [progressBarHide, setProgressBarHide] = useState(false)
  const [sendingCandidate, setSendingCandidate] = useState(false);

  const [roleChanging, setRoleChanging] = useState(false);
  const [categoryChanging, setCategoryChanging] = useState(false);

  const [trialPlanExpiredAndJobCountZeroDetails, setTrialPlanExpiredAndJobCountZeroDetails] = useState({})


  const getCandidateDatas = async (jobIdProps, changeRole, notesUpdate, sendingCandidateIdFromHome, candidateFromNotification) => {
    setFilterSkills([]);
    setFilterLocation([]);
    setJobStatus("All");

    if (notesUpdate === undefined) {
      if (changeRole === true) {
        setCategorySelectedGlow(true)
      } else {
        setInitialGlow(true);
        setMellieSearchSkills([]);
        setMellieSearchLocations([]);
      }
    }
    if (jobIdProps && candidateFromNotification) {
      var obj = {
        job_id: jobIdProps
      }

      setSelectedJobRoleId(jobIdProps)
    } else {
      if (jobIdProps === undefined && changeRole === false) {
        var obj = {
          job_id: 0,
          job_status: roleStatus,
        };
      }
      else if (jobIdProps !== undefined && changeRole === true) {
        var obj = {
          job_id: jobIdProps,
          job_status: roleStatus,
        };
        setSelectedJobRoleId(jobIdProps)
      }
      else if (jobIdProps !== undefined && changeRole === "changeRole") {
        var obj = {
          job_id: jobIdProps,
          job_status: sendingCandidateIdFromHome,
        };
        setRoleStatus(sendingCandidateIdFromHome)
        setSelectedJobRoleId(jobIdProps)
      }
      else if (changeRole === "filterchangeRole") {
        var obj = {
          job_id: '',
          job_status: sendingCandidateIdFromHome,
        };
        setRoleStatus(sendingCandidateIdFromHome)
      }
      else {
        var obj = {
          job_id: '',
          job_status: roleStatus,
        };
      }
    }

    try {
      setRoleChanging(true)
      const res = await axiosInstance.post(jobIdProps && candidateFromNotification ? "/applicants_view_mail" : "/candidates_dashboard_view", obj)

      if (res.data.error_code === 0 || res.data.error_code === 200) {
        if (res.data.data.candidates_short_desc.length > 0) {
          setEmployerExpertNotes(res.data.data.candidates_short_desc[0].expert_notes)
          setRecommendedDatas({
            ...recommendedDatas,
            sc_recommended_notes: res.data.data.candidates_short_desc[0].sc_recommended_notes,
            recommended_by: res.data.data.candidates_short_desc[0].recommended_by
          })
        } else {
          setRecommendedDatas({
            ...recommendedDatas,
            sc_recommended_notes: "",
            recommended_by: ""
          })
        }

        if (notesUpdate === undefined) {
          if (jobIdProps === undefined && changeRole === false) {
            if (res.data.data.job_list.length > 0) {
              setJobListContent({
                ...jobListContent,
                id: res.data.data.job_list[0].id,
                job_title: res.data.data.job_list[0].job_title,
                posted_on: res.data.data.job_list[0].posted_on,
                company_name: res.data.data.job_list[0].company_name,
                job_status: res.data.data.job_list[0].job_status
              });

              setContentForEmail({
                ...contentForEmail,
                id: res.data.data.job_list[0].id,
                job_title: res.data.data.job_list[0].job_title,
                posted_on: res.data.data.job_list[0].posted_on,
                company_name: res.data.data.job_list[0].company_name,
                job_status: res.data.data.job_list[0].job_status,
                designation: res.data.data.job_list[0].designation,
                first_name: res.data.data.job_list[0].first_name,
                last_name: res.data.data.job_list[0].last_name,
                email_id: res.data.data.job_list[0].email_id
              })

              setRoleStatus(res.data.data.job_list[0].job_status)
              setSelectedJobRoleId(res.data.data.job_list[0].id)
            } else {
              setJobListContent({
                ...jobListContent,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: ''
              });

              setContentForEmail({
                ...contentForEmail,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: '',
                designation: '',
                first_name: '',
                last_name: '',
                email_id: ''
              })

              setSelectedJobRoleId(null)
            }
          }
          else if (jobIdProps && changeRole === true) {
            var filterGettingJobId = res.data.data.job_list.filter(
              (v) => {
                return v.id === jobIdProps;
              }
            );

            if (filterGettingJobId.length > 0) {
              setJobListContent({
                ...jobListContent,
                id: filterGettingJobId[0].id,
                job_title: filterGettingJobId[0].job_title,
                posted_on: filterGettingJobId[0].posted_on,
                company_name: filterGettingJobId[0].company_name,
                job_status: filterGettingJobId[0].job_status
              });

              setContentForEmail({
                ...contentForEmail,
                id: filterGettingJobId[0].id,
                job_title: filterGettingJobId[0].job_title,
                posted_on: filterGettingJobId[0].posted_on,
                company_name: filterGettingJobId[0].company_name,
                job_status: filterGettingJobId[0].job_status,
                designation: filterGettingJobId[0].designation,
                first_name: filterGettingJobId[0].first_name,
                last_name: filterGettingJobId[0].last_name,
                email_id: filterGettingJobId[0].email_id
              })

              setRoleStatus(filterGettingJobId[0].job_status)
              setSelectedJobRoleId(filterGettingJobId[0].id)
            } else {
              setJobListContent({
                ...jobListContent,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: ''
              });

              setContentForEmail({
                ...contentForEmail,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: '',
                designation: '',
                first_name: '',
                last_name: '',
                email_id: ''
              })

              setSelectedJobRoleId(null)
            }
          }
          else if (jobIdProps !== undefined && changeRole === "changeRole") {
            var filterGettingJobId = res.data.data.job_list.filter(
              (v) => {
                return v.id === jobIdProps;
              }
            );

            if (filterGettingJobId.length > 0) {
              setJobListContent({
                ...jobListContent,
                id: filterGettingJobId[0].id,
                job_title: filterGettingJobId[0].job_title,
                posted_on: filterGettingJobId[0].posted_on,
                company_name: filterGettingJobId[0].company_name,
                job_status: filterGettingJobId[0].job_status
              });

              setContentForEmail({
                ...contentForEmail,
                id: filterGettingJobId[0].id,
                job_title: filterGettingJobId[0].job_title,
                posted_on: filterGettingJobId[0].posted_on,
                company_name: filterGettingJobId[0].company_name,
                job_status: filterGettingJobId[0].job_status,
                designation: filterGettingJobId[0].designation,
                first_name: filterGettingJobId[0].first_name,
                last_name: filterGettingJobId[0].last_name,
                email_id: filterGettingJobId[0].email_id
              })

              setSelectedJobRoleId(filterGettingJobId[0].id)
              setRoleStatus(filterGettingJobId[0].job_status)
            } else {
              setJobListContent({
                ...jobListContent,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: ''
              });

              setContentForEmail({
                ...contentForEmail,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: '',
                designation: '',
                first_name: '',
                last_name: '',
                email_id: ''
              })

              setSelectedJobRoleId(null)
            }
          }
          else { 
            if (res.data.data.job_list.length > 0) {
              setJobListContent({
                ...jobListContent,
                id: res.data.data.job_list[0].id,
                job_title: res.data.data.job_list[0].job_title,
                posted_on: res.data.data.job_list[0].posted_on,
                company_name: res.data.data.job_list[0].company_name,
                job_status: res.data.data.job_list[0].job_status
              });

              setContentForEmail({
                ...contentForEmail,
                id: res.data.data.job_list[0].id,
                job_title: res.data.data.job_list[0].job_title,
                posted_on: res.data.data.job_list[0].posted_on,
                company_name: res.data.data.job_list[0].company_name,
                job_status: res.data.data.job_list[0].job_status,
                designation: res.data.data.job_list[0].designation,
                first_name: res.data.data.job_list[0].first_name,
                last_name: res.data.data.job_list[0].last_name,
                email_id: res.data.data.job_list[0].email_id
              })

              setRoleStatus(res.data.data.job_list[0].job_status)
              setSelectedJobRoleId(res.data.data.job_list[0].id)
            } else {
              setJobListContent({
                ...jobListContent,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: ''
              });

              setContentForEmail({
                ...contentForEmail,
                id: 0,
                job_title: 'No Data Found',
                posted_on: '',
                company_name: '',
                job_status: '',
                designation: '',
                first_name: '',
                last_name: '',
                email_id: ''
              })

              setSelectedJobRoleId(null)
            }
          }

          setCandidatesList(res.data.data.candidates_short_desc);
          setCandidatesListDuplicate(res.data.data.candidates_short_desc);

          setJobId(res.data.data.job_id);
          setAppStatus(res.data.data.application_status);
          setRightSideContent(res.data.data);
          setApplicantFeedback(res.data.data?.feedback)
          setJobRole(res.data.data.job_list);

          if (res.data.data.candidates_short_desc.length > 0) {
            setRole(res.data.data.candidates_short_desc[0].job_title);
          }

          if (res.data.data.professional_id !== "") {
            setProfessionalId(res.data.data.professional_id);
          } else {
            setProfessionalId(0);
          }

          setKeepNotes(res.data.data.custom_notes === null ? "" : res.data.data.custom_notes);

          //skills data for filter
          var orderingcandidateSkills = res.data.data.filter_parameters.skill.sort();
          var candidateSkillsConvertion = orderingcandidateSkills.map((v, i) => {
            return { value: i + 1, label: v, disabled: false };
          });
          setFilterSkills(candidateSkillsConvertion)

          //Location data for filter
          res.data.data.filter_parameters.location.map((v, i) => {
            return i >= 0
              ? setFilterLocation((prevState) => [
                ...prevState,
                {
                  value: i + 1,
                  label: v,
                  disabled: false
                },
              ])
              : null;
          });

          if (!candidateFromNotification) {
            setInitialGlow(false);
            setCategorySelectedGlow(false);
          } else {
            var filterGettingJobId = res.data.data.job_list.filter((v) => {
              return v.id === jobIdProps;
            });

            if (filterGettingJobId?.length) {
              setJobListContent({
                ...jobListContent,
                id: filterGettingJobId[0].id,
                job_title: filterGettingJobId[0].job_title,
                posted_on: filterGettingJobId[0].posted_on,
                company_name: filterGettingJobId[0].company_name,
                job_status: filterGettingJobId[0].job_status
              });

              setContentForEmail({
                ...contentForEmail,
                id: filterGettingJobId[0]?.id,
                job_title: filterGettingJobId[0].job_title,
                posted_on: filterGettingJobId[0].posted_on,
                company_name: filterGettingJobId[0].company_name,
                job_status: filterGettingJobId[0].job_status,
                designation: filterGettingJobId[0].designation,
                first_name: filterGettingJobId[0].first_name,
                last_name: filterGettingJobId[0].last_name,
                email_id: filterGettingJobId[0].email_id
              })
              setRoleStatus(filterGettingJobId[0].job_status) 
              setSelectedJobRoleId(filterGettingJobId[0].id)
            } else {
              setSelectedJobRoleId(null)
            }
            selectedProfessionalDetails(jobIdProps, candidateFromNotification, undefined, true)
          }

        } else {
          //updating keep notes when the job category is "ALL"
          setCandidatesList(res.data.data.candidates_short_desc);
          setCandidatesListDuplicate(res.data.data.candidates_short_desc);

          const updateTakeNotes = res.data.data.candidates_short_desc.filter((v) => {
            return v.professional_id === professionalId
          })
          setRightSideContent({ ...rightSideContent, custom_notes: updateTakeNotes[0].custom_notes })
          setKeepNotes(updateTakeNotes[0].custom_notes);
          document.getElementById("closeApplyModal").click();
          setUpdatingKeepNotes(false);
          setUpdatingClearNotes(false);
        }
        setRoleChanging(false)
      } else {
        setInitialGlow(false);
        setRoleChanging(false)
        setCategorySelectedGlow(false);
        setRightSideContent({});
        setCandidatesList([]);
        setCandidatesListDuplicate([]);
      }
      setSendingCandidate(false)
      setRoleChanging(false)
    } catch (err) {
      console.log(err);
    }
  };

  const selectedProfessionalDetails = async (job_id, professional_id, recall, candidateFromNotification) => {
    if (recall === "recalling") {
      setCardSelectedGlow(false);
    } else {
      setCardSelectedGlow(true);
    }

    var obj = {
      job_id: job_id,
      professional_id: professional_id,
    };

    try {
      const res = await axiosInstance.post("/get_selected_professional_detail", obj);

      if (res.data.error_code === 0) {
        if (recall === "recalling") {
          setSelectCandidateStatus(false)
          setRejectCandidateStatus(false)
          setinviteToInterviewStatus(false)
        }
        setCardSelectedGlow(false);
        setRightSideContent(res.data.data);
        setApplicantFeedback(res.data.data?.feedback)
        setProfessionalId(res.data.data.professional_id);
        setJobId(res.data.data.job_id);
        setAppStatus(res.data.data.application_status);
        if (res.data.data.experience.length > 0) {
          setRole(res.data.data.experience[0].job_title);
        }
        setKeepNotes(res.data.data.custom_notes === null ? "" : res.data.data.custom_notes);
        setApplicantFeedbackModel(false)


        if (Cookies.get("Prof_id")) {
          Cookies.remove("Prof_id")
        }

        if (Cookies.get("job_id")) {
          Cookies.remove("job_id")
        }

        if (Cookies.get("job_status")) {
          Cookies.remove("job_status")
        }
      } else {
        if (recall === "recalling") {
          setSelectCandidateStatus(false)
          setRejectCandidateStatus(false)
        }
        setCardSelectedGlow(false);
        setRightSideContent({});
        setApplicantFeedbackModel(false)
      }

      if (candidateFromNotification) {
        setInitialGlow(false);
        setCategorySelectedGlow(false);
      }
    } catch (err) {
      console.log(err);
      setApplicantFeedbackModel(false)
    }
  };

  const handleCategoryStatus = async (jobStatus, recall, updateNotes) => {
    setJobStatus(jobStatus);
    setRecommendedDatas({
      ...recommendedDatas,
      sc_recommended_notes: "",
      recommended_by: ""
    })
    if (jobStatus !== "All") {
      if (recall === "Applied" || recall === "Not Reviewed" || recall === "Shortlisted" || recall === "Recommended") {
        setCategorySelectedGlow(false);
      } else {
        setCategorySelectedGlow(true);
      }

      var obj = {
        job_id: jobId,
        status: jobStatus,
      };

      try {
        setCategoryChanging(true)
        const res = await axiosInstance.post("/filter_by_application_status", obj)
        if (res.data.error_code == 0) {
          setCategoryChanging(false)
          setSelectCandidateStatus(false)
          setRejectCandidateStatus(false)
          setinviteToInterviewStatus(false)
          setCategorySelectedGlow(false);
          setApplicantFeedbackModel(false)
          if (res.data.data.job_id !== undefined) {

            setAppStatus(res.data.data.application_status);
            setCandidatesList(res.data.data.candidates_short_desc);
            setCandidatesListDuplicate(res.data.data.candidates_short_desc);
            setRightSideContent(res.data.data);
            setApplicantFeedback(res.data.data?.feedback)
            setKeepNotes(res.data.data.candidates_short_desc[0].custom_notes);

            if (recall) {
              if (updateNotes === "updateNotes") {
                setUpdatingKeepNotes(false)
                setUpdatingClearNotes(false)
                document.getElementById("closeApplyModal").click();
              }
            }

            setProfessionalId(res.data.data.professional_id);
            if (res.data.data.experience.length > 0) {
              setRole(res.data.data.experience[0].job_title);
            }
          } else {
            setRightSideContent({});
            setCandidatesList([]);
            setCandidatesListDuplicate([]);
          }
        } else {
          setCategoryChanging(false)
          setCategorySelectedGlow(false);
          setApplicantFeedbackModel(false)
          setRightSideContent({});
          setCandidatesList([]);
          setCandidatesListDuplicate([]);
        }
      } catch (err) {
        console.log(err);
        setApplicantFeedbackModel(false)
      }
    } else {
      getCandidateDatas(jobId, true);
    }
  };

  const handleMellieSearch = async (filterType) => {
    const sendSkills = mellieSearchSkills.map((v) => {
      return v.label;
    });

    const locationConvertion = location.map((v) => {
      const originalVal = v.split(',')
      const joinOriginalValue = originalVal.join('&&&&&')

      return joinOriginalValue
    })

    const obj = {
      job_id: jobId,
      skills: sendSkills,
      location: locationConvertion,
    };

    if (filterType === "ApplyFilter") {
      if (sendSkills.length > 0 || location.length > 0) {
        setCategorySelectedGlow(true);
        setOpenWidget(false)
        try {
          const res = await axiosInstance.post("/filter_professionals", obj)
          setCategorySelectedGlow(false);
          if (res.data.error_code === 0) {
            if (res.data.data.professional_id !== undefined) {
              setCategorySelectedGlow(false);
              setCandidatesList(res.data.data.candidates_short_desc);
              setCandidatesListDuplicate(
                res.data.data.candidates_short_desc
              );
              setProfessionalId(res.data.data.professional_id);
              setJobId(res.data.data.job_id);
              setAppStatus(res.data.data.application_status);
              setRightSideContent(res.data.data);
              setApplicantFeedback(res.data.data?.feedback)
              if (res.data.data.candidates_short_desc.length > 0) {
                setRole(res.data.data.candidates_short_desc[0].job_title);
              }
              setKeepNotes(res.data.data.custom_notes === null ? "" : res.data.data.custom_notes);
            } else {
              toast.error(res.data.message);
              setRightSideContent({});
              setCandidatesList([]);
              setCandidatesListDuplicate([]);
            }
          } else {
            setRightSideContent({});
            setCandidatesList([]);
            setCandidatesListDuplicate([]);
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        toast.error("nothing selected");
      }
    } else {
      dispatch(handleReset())

      setMellieSearchSkills([]);
      setMellieSearchLocations([]);
      getCandidateDatas(jobId, true);
      setJobStatus("All");
      setOpenWidget(false)
    }
  };

  //home page functions
  const displayStep = (stepNumber) => {
    if (stepNumber === 1) {
      setExistingTemplate(false);
      setCreateJobId({
        job_title: "",
        job_type: "",
        work_schedule: "",
        workplace_type: "",
        country: "",
        city: "",
        job_overview: "",
        specialisation: "",
        required_subcontract: "",
        skills: "",
        time_zone: null,
        job_desc: "",
        required_resume: "",
        required_cover_letter: "",
        required_background_check: "",
        time_commitment: "",
        duration: "",
        job_status: "",
        is_paid: "",
        is_active: "",
        question_list: [],
      });
      setShowFieldOne(true);
      setShowFieldTwo(false);
      setShowFieldThree(false);
      setShowFieldFour(false);
    } else if (stepNumber === 2) {
      setShowFieldOne(false);
      setShowFieldTwo(true);
      setShowFieldThree(false);
      setShowFieldFour(false);
    } else if (stepNumber === 3) {
      setShowFieldOne(false);
      setShowFieldTwo(false);
      setShowFieldThree(true);
      setShowFieldFour(false);
    } else if (stepNumber === 4) {
      setShowFieldOne(false);
      setShowFieldTwo(false);
      setShowFieldThree(false);
      setShowFieldFour(true);
    }

    setTimeout(() => {
      if (stepNumber >= 1 && stepNumber <= 4) {
        document.querySelector(".step-" + currentStep).style.visibility =
          "hidden";
        document.querySelector(".step-" + stepNumber).style.visibility =
          "visible";
        currentStep = stepNumber;
        updateProgressBar();
      }
    }, 0)
  };

  updateProgressBar = function () {
    var progressPercentage = ((currentStep - 1) / 3) * 100;
    document.querySelector(".progress-bar").style.width =
      progressPercentage + "%";
  };

  document.addEventListener("DOMContentLoaded", function () {
    var multiStepForm = document.getElementById("multi-step-form");
    if (multiStepForm) {
      var steps = multiStepForm.querySelectorAll(".step");
      if (steps) {
        for (var i = 1; i < steps.length; i++) {
          steps[i].style.display = "none";
        }
      }

      var nextButtons = document.querySelectorAll(".next-step");
      if (nextButtons) {
        nextButtons.forEach(function (button) {

          button.addEventListener("click", function () {

            if (currentStep < 4) {
              document
                .querySelector(".step-" + currentStep)
                .classList.add("animate__animated", "animate__fadeOutLeft");
              currentStep++;
              setTimeout(function () {
                var steps = document.querySelectorAll(".step");
                steps.forEach(function (step) {
                  step.classList.remove(
                    "animate__animated",
                    "animate__fadeOutLeft"
                  );
                  step.style.display = "none";
                });
                document.querySelector(".step-" + currentStep).style.display =
                  "block";
                document
                  .querySelector(".step-" + currentStep)
                  .classList.add("animate__animated", "animate__fadeInRight");
                updateProgressBar();
              }, 500);
            }
          });
        });
      }

      var prevButtons = document.querySelectorAll(".prev-step");
      if (prevButtons) {
        prevButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            if (currentStep > 1) {
              document
                .querySelector(".step-" + currentStep)
                .classList.add("animate__animated", "animate__fadeOutRight");
              currentStep--;
              setTimeout(function () {
                var steps = document.querySelectorAll(".step");
                steps.forEach(function (step) {
                  step.classList.remove(
                    "animate__animated",
                    "animate__fadeOutRight"
                  );
                  step.style.display = "none";
                });
                document.querySelector(".step-" + currentStep).style.display =
                  "block";
                document
                  .querySelector(".step-" + currentStep)
                  .classList.add("animate__animated", "animate__fadeInLeft");
                updateProgressBar();
              }, 500);
            }
          });
        });
      }
    }
  });


  // Get Job Api
  const handleGetJobApi = async (templateName) => {
    setPageOneLoading(false);

    //for getting previous job templates
    if (templateName === 'getPreviousJobTemplates') {
      var obj = {
        job_status: ''
      }
      try {

        const response = await axiosInstance.post("/get_job_post", obj);
        if (response.data.error_code === 0) {
          if (response.data.data.length > 0) {
            setGetJobApi(response.data.data);
          } else {
            setGetJobApi([]);
          }
          setPageOneLoading(true);
        }
      } catch (err) {
        console.log(err);
      }
    }

    //for getting draft templates
    else {
      var obj = {
        job_status: 'drafted'
      }
      try {
        const response = await axiosInstance.post("/get_job_post", obj);
        if (response.data.error_code === 0) {
          if (response.data.data.length > 0) {
            setGetJobApi(response.data.data);
          } else {
            setGetJobApi([]);
          }
          setPageOneLoading(true);
        }
      } catch (err) {
        console.log(err);
      }
    }

  };

  //  Pricing****************************************************************************************************************************************************
  const [checkOutStatus, setCheckOutStatus] = useState({
    paymentStatus: '',
    productPlan: ''
  })

  const [country, setCountry] = useState("")

  const [countryLoading, setCountryLoading] = useState(false)

  const getCoordinates = async () => {
    let getCountryParameters = { lat: '', lon: '' };

    const getPosition = () =>
      new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve({ lat: latitude.toString(), lon: longitude.toString() });
            },
            (error) => {
              reject(error);
            }
          );
        } else {
          reject(new Error('Geolocation is not supported by this browser.'));
        }
      });

    try {
      getCountryParameters = await getPosition();
    } catch (error) {
      getCountryParameters = { lat: '43.000000', lon: '-75.000000' }; // Default values
    }

    return getCountryParameters;
  };

  const updateCheckoutStatus = async () => {
    try {
      const getCountryParameters = await getCoordinates();
      setCountryLoading(true)

      const response = await axiosInstance.post("/get_checkout_status", getCountryParameters);
      if (response.data.error_code === 0) {
        setCountryLoading(false)
        setCheckOutStatus({ paymentStatus: response.data.data.payment_status, productPlan: response.data.data.product_plan, is_cancelled: response.data.data?.is_cancelled })
        set_is_trial_started(response.data.data.is_trial_started)
        setCountry(response.data.data.country)
        setPricingResponse(response.data.data)
        set_subscription_going_to_end(response.data?.data?.remaining_days)
        if (response.data.data?.product_plan) {
          Cookies.set("pricing_category", response.data.data?.product_plan);
        }
      } else {
        toast(response.data.message, {
          icon: (
            <h4><IoIosInformationCircleOutline className="brand-color me-1" /></h4>
          )
        });
      }
    } catch (error) {
      console.log(error)
    }
  }

  const get_payment_status = async () => {
    try {
      const res = await axiosInstance.get('/get_payment_status_employer')

      setTrialPlanExpiredAndJobCountZeroDetails(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <employerContext.Provider
      value={{

        // Pricing
        country,
        setCountry,
        checkOutStatus,
        setCheckOutStatus,
        countryLoading,
        setCountryLoading,
        selectedJobRoleId,
        setSelectedJobRoleId,
        is_trial_started,
        set_is_trial_started,
        pricingResponse,
        setPricingResponse,
        subscription_going_to_end,
        getCoordinates,

        roleChanging,
        categoryChanging,
        inviteToInterviewStatus,
        setinviteToInterviewStatus,
        selectCandidateStatus,
        setSelectCandidateStatus,
        rejectCandidateStatus,
        setRejectCandidateStatus,
        updateKeepNotes, setUpdatingKeepNotes,
        updateClearNotes, setUpdatingClearNotes,
        employerExpertNotes, setEmployerExpertNotes,
        recommendedDatas, setRecommendedDatas,
        profile, setProfilePicture,
        openWidget,
        setOpenWidget,
        smallDevice,
        setSmallDevice,
        candidatesList,
        setCandidatesList,
        candidatesListDuplicate,
        setCandidatesListDuplicate,
        jobRole,
        setJobRole,
        keepNotes,
        setKeepNotes,
        rightSideContent,
        setRightSideContent,
        filterSkills,
        setFilterSkills,
        filterLocation,
        setFilterLocation,
        professionalId,
        setProfessionalId,
        jobId,
        setJobId,
        role,
        setRole,
        appStatus,
        setAppStatus,
        initialGlow,
        setInitialGlow,
        cardSelectedGlow,
        setCardSelectedGlow,
        categorySelectedGlow,
        setCategorySelectedGlow,
        jobStatus,
        setJobStatus,
        roleStatus,
        setRoleStatus,
        jobListContent,
        setJobListContent,
        getCandidateDatas,
        selectedProfessionalDetails,
        handleCategoryStatus,
        mellieSearchSkills,
        setMellieSearchSkills,
        mellieSearchLocations,
        setMellieSearchLocations,
        handleMellieSearch,
        sendingCandidate,
        setSendingCandidate,
        // Home and MultiStepForm
        handleGetJobApi,
        pageOneLoading,
        setPageOneLoading,
        getJobApi,
        setGetJobApi,
        homeResponseReview,
        setHomeResponseReview,
        createJobId,
        setCreateJobId,
        editingJobStatus,
        setEditingJobStatus,
        existingTemplate,
        setExistingTemplate,
        pageTwoJobDetails,
        setPageTwoJobDetails,
        jobLocation,
        setJobLocation,
        pageThreeJobDetails,
        setPageThreeJobDetails,
        pageFourJobDetails,
        setPageFourJobDetails,
        specificSpecialization,
        setSpecificSpecialization,
        showProgressBar, setShowProgressBar,
        showReview, setShowReview,
        showFieldOne, setShowFieldOne,
        showFieldTwo, setShowFieldTwo,
        showFieldThree, setShowFieldThree,
        showFieldFour, setShowFieldFour,
        displayStep,
        progressBarHide,
        setProgressBarHide,
        selctedTemplateCard, setSelectedTemplateCard,
        editingJobFromHome, setEditingJobFromHome,
        txtdurations, settxtDurations,
        showingJobLocation, setShowingJobLocation,
        editCompanyLocation, setEditCompanyLocation,
        postDraftTemplate, setPostDraftTemplate,
        contentForEmail, setContentForEmail,
        pageThreeSkillDataResponse, setPageThreeSkillDataResponse,
        postButton, setPostButton,
        subscriptionExpiredShow, setSubscriptionExpired,
        // Joy ride

        employerProfileDropdown,
        employerApplicants,
        employerPool,

        // Trial Plan expire and job count zero
        trialPlanExpiredAndJobCountZeroDetails,
        setTrialPlanExpiredAndJobCountZeroDetails,
        get_payment_status,


        applicantFeedbackModel, setApplicantFeedbackModel,
        applicantFeedback, setApplicantFeedback,

        updateCheckoutStatus
      }}
    >
      {children}
    </employerContext.Provider>
  );
};

export default employerContext;
